export const vfNetWorkCheck = () => {
    const hostname = window.location.hostname;
    const qaHosts = ["www.mintmobile.dev", "qa.mintmobile.com", "localhost"];
    const prodEndpoint = "https://w3b-api.ultramobile.com/v1/network/check";
    const qaEndpoint = "https://w3b-api-qa.ultramobile.com/v1/network/check";
    return (qaHosts.includes(hostname)) ? qaEndpoint : prodEndpoint;
}